<style lang="scss">
  .slider {
    & .v-slider__thumb {
      border-radius: 40%;
    }
    & .v-slider--horizontal .v-slider__track-container {
      height: 2px;
    }
  }
</style>

<template>
    <div class="slider">
      <h4 class="slider__label">{{ label }}</h4>
      <slot></slot>
      <v-row class="text-center" >
        <v-col>
          <v-slider
            v-model="sliderValue"
            :min="min"
            :max="max"
            :step="step"
  
            color="primary"
            thumb-color="action"
            track-color="secondary"
            
            :key="updateKey"
            @mouseup="$nextTick(() => updateKey++)"
          ></v-slider>  
          
          <div class="text-left pl-2" style="margin-top: -20px;">{{ this.min }}<span class="pr-2" style="float:right">{{ this.max }}</span></div>
          
          <!-- <Select 
              v-model="sliderValue" 
              :list="ticksList"
              class="input-wrapper mt-10"
              :fieldHeight="fieldHeight"
              >
          </Select> -->
          

          <div class="input-wrapper mt-10">
            <v-autocomplete
              v-model="sliderValue"
              :items="ticksList"
              no-data-text="Введите из списка"

              solo
              flat             
              validate-on-blur

              :height="fieldHeight"
              >

            </v-autocomplete>
          </div>
          
        </v-col>
      </v-row>
    </div>
  </template>
  
  <script>
// import Select from "./Select.vue";

  export default {
    name: "Slider",
    components: {
        // Select
    },
    props: {
      value: Number,
      fieldHeight: String,
      min: Number,
      label: String,
      max: Number,
      step: Number,
      comment: String,
      ticks: Array,
    },
    data: () => ({ updateKey: 0 }),
    computed: {
      sliderValue: {
        get() {
          return this.value
        },
        set(val) {
          const ticks = this.ticks;
          let deltas = [];
          let min;
  
          if (!ticks) {
            this.$emit('input', val);
          } else {
            deltas = ticks.map( tick => Math.abs(tick - val) );
            min = Math.min(...deltas);
            this.$emit('input', ticks[deltas.indexOf(min)]);
          }
         
        }
      },
      ticksList() {
        return this.ticks || this.getTicksList();
      }
  
    },
    methods: {
      getTicksList() {
        let ticksList = [];
        let val = this.min;

        while( val <= this.max) {
          ticksList.push(val);
          val += this.step;
        }
        
        return ticksList;
      }
    }
  }
  </script>
  